import { Progress } from 'antd'
import { Auth } from 'aws-amplify'
import React, { useEffect, useMemo, useState } from 'react'
import { Unity, useUnityContext } from 'react-unity-webgl-latest'
import { config } from '../../../../../../../constants'
import './SimulationStyles.scss'
import { useTranslation } from 'react-i18next'

const SimulationUnityView = ({
  unityUrl,
  simulationId,
  userId,
  token,
  ids,
  isEnableModal,
  sim_data,
  sim_mode
}) => {
  const { loaderUrl, dataUrl, frameworkUrl, codeUrl } = unityUrl
  const { lessonId, courseId, pageId } = ids

  // Conditional Unity Context Initialization
  const {
    unityProvider,
    addEventListener,
    removeEventListener,
    sendMessage,
    isLoaded,
    unload,
    loadingProgression,
    error: unityError
  } = useUnityContext(
    sim_mode === 'simulation' || sim_mode === 'interactive'
      ? {
        loaderUrl: '/SimBuild/SimBuild.loader.js',
        dataUrl: '/SimBuild/SimBuild.data',
        frameworkUrl: '/SimBuild/SimBuild.framework.js',
        codeUrl: '/SimBuild/SimBuild.wasm',
        streamingAssetsUrl: '/SimBuild/StreamingAssets',
      }
      : {
        loaderUrl,
        dataUrl,
        frameworkUrl,
        codeUrl
      }
  )

  const [unityUnloaded, setUnityUnloaded] = useState(false)

  useEffect(() => {
    return () => {
      handleUnloadUnity()
    }
  }, [])

  const loadingPercentage = useMemo(
    () => Math.round(loadingProgression * 100),
    [loadingProgression]
  )

  const getAccessJwtToken = async () => {
    const session = await Auth.currentSession()
    const newToken = await session.idToken.jwtToken
    return newToken
  }

  const handleNewToken = async msg => {
    if (msg === 'token_needed') {
      const token = await getAccessJwtToken()
      sendMessage('Data', 'Get_Fresh_Token', String(token))
    }
  }

  const handleUnloadUnity = () => {
    if (isLoaded && unityProvider) {
      unload()
        .then(() => {
          console.log('Unity instance successfully unloaded.')
          setUnityUnloaded(true)
        })
        .catch(error => {
          console.error('Error during Unity unload:', error)
        })
    } else {
      console.warn('Unity instance is not instantiated; skipping unload.')
    }
  }

  useEffect(() => {
    if (isLoaded) {
      console.log('=== Unity Data Being Sent ===')
      console.log('courseId:', courseId)
      console.log('userId:', userId)
      console.log('simulationId:', simulationId)
      console.log('token:', token)
      console.log('baseURL:', config.baseURL)
      console.log('lessonId:', lessonId)
      console.log('pageId:', pageId)
      console.log('Sim_Data:', sim_data)
      console.log('Sim_Mode:', sim_mode)
      console.log('Sim_Data (stringified):', JSON.stringify(sim_data))
      console.log('================================')

      sendMessage('Data', 'Get_courseid', String(courseId))
      sendMessage('Data', 'Get_userid', String(userId))
      sendMessage('Data', 'Get_simulationid', String(simulationId))
      sendMessage('Data', 'Get_token', String(token))
      sendMessage('Data', 'Get_baseurl', String(config.baseURL))
      sendMessage('Data', 'Get_lessonid', String(lessonId))
      sendMessage('Data', 'Get_pageid', String(pageId))

      // Get original data
      const originalData = {
        title: "Sample Simulation",
        is_simulation: true,
        content_type: "Simulation",
        simulation: {
          title: "Sample Simulation",
          score: 50,
          sim_data: sim_data,
          simulationMode: "simulation"
        },
        lesson_id: lessonId,
        course_id: courseId
      };

      let dataToSend;

      if (sim_mode?.toLowerCase()?.trim() !== "interactive") {
        dataToSend = originalData;
      } else {
        // Transform to unity_lesson format
        dataToSend = {
          title: "Unity Lesson",
          is_simulation: false,
          content_type: "UnityLesson",
          unity_lesson: {
            title: "Unity Lesson",
            score: 50,
            lesson_data: originalData.simulation.sim_data,
            simulationMode: "interactive"
          },
          lesson_id: originalData.lesson_id,
          course_id: originalData.course_id
        };
      }

      console.log('dataToSend:', dataToSend)

      // Send the appropriate data
      sendMessage('Data', 'Get_simdata', JSON.stringify(dataToSend));

      addEventListener('GetToken', handleNewToken)
      addEventListener('ExitGame', handleUnloadUnity)
    }

    return () => {
      removeEventListener('GetToken', handleNewToken)
      removeEventListener('ExitGame', handleUnloadUnity)
    }
  }, [isLoaded])

  useEffect(() => {
    handleUnloadUnity()
  }, [isEnableModal])

  const { t } = useTranslation()

  return (
    <div className="simulation-wrapper">
      <div className="simulation-unity-container" id="simulationUnity">
        <div className="simulation-aspect-wrapper">
          {unityUnloaded && (
            <div className="simulation-unloaded">
              <span>{t('v4:simulation_has_been_stopped')}</span>
            </div>
          )}

          {isLoaded === false && !unityError && (
            <div className="simulation-loading">
              <div className="simulation-progress">
                <Progress type="circle" percent={loadingPercentage} />
              </div>
              <span>
                {sim_mode?.toLowerCase()?.trim() === "interactive"
                  ? t('Loading Interactive Lesson...')
                  : t('v4:loading_simulation')}
              </span>

            </div>
          )}

          {!unityUnloaded && (
            <div className="simulation-player">
              <Unity unityProvider={unityProvider} />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default SimulationUnityView
